import { gql } from '@apollo/client';
import { client as apolloClient } from '@xbcb/apollo-client';

const GENERATE_JWT = gql`
  query GenerateJWT($login: String!) {
    generateJWT(login: $login)
  }
`;

export const getConnectProToken = async (login: string): Promise<string> => {
  try {
    const { data } = await apolloClient.query({
      query: GENERATE_JWT,
      variables: { login },
    });
    return data?.generateJWT || '';
  } catch (error) {
    console.error('Failed to generate JWT token:', error);
    return '';
  }
};
